module.exports = __webpack_public_path__ + "static/media/Template_43.34f3e361.png";